/**
 * Table tennis court finish — same blue family as pickleball; fixed presentation.
 */
/** Calm ocean-blue — identical to `PickleballCourtSvgs` COURT_BLUE. */
export const TABLE_TENNIS_TABLE_BLUE = "#3a6f9a";
/** Deeper wash for the area around the table (pickleball kitchen family). */
export const TABLE_TENNIS_SURROUND_BLUE = "#12304e";

export const TABLE_TENNIS_COURT_COLOURS = Object.freeze(["blue"]);
export const TABLE_TENNIS_COURT_COLOUR_DEFAULT = "blue";
export const TABLE_TENNIS_COURT_COLOUR_LABELS = Object.freeze({ blue: "Blue" });
export const TABLE_TENNIS_COURT_COLOUR_SWATCHES = Object.freeze({
  blue: TABLE_TENNIS_TABLE_BLUE,
});

export function normalizeTableTennisCourtColour(value) {
  if (TABLE_TENNIS_COURT_COLOURS.includes(value)) return value;
  return TABLE_TENNIS_COURT_COLOUR_DEFAULT;
}

export function nextTableTennisCourtColour(current) {
  return normalizeTableTennisCourtColour(current);
}
